module.exports = __webpack_public_path__ + "img/filmi_logo_bl_stg_2.a90d7514.svg";